const pidginLanguageNameMapping: {[key: string]: string} = {
  en: 'Italian',
  en_GB: 'Italian',
  de: 'Italienisch',
  fr: 'd\'italien',
  it: 'italiano',
  es: 'italiano',
  pl: 'włoskiego',
  pt: 'italiano',
  sv: 'italienska'
};

export const getPidginLanguageName = (locale: string): string =>
  pidginLanguageNameMapping[locale];
